import { ApiFetch } from '../../../shared/utils/fetch'

export interface DashboardSummary {
  totalRevenue: number
  /**
   * Revenue − COGS. Null when the backend can't resolve cost for every sold
   * item (PE-1188) — render as "N/A" rather than ₦0 so we never imply zero profit.
   */
  totalProfit: number | null
  totalOutOfStock: number
  totalProducts: number
  totalOrders: number
  uniqueCustomers: number
  currency?: string
  execution_time_ms: number
}

export const dashboardApi = {
  getSummary: async (): Promise<DashboardSummary> => {
    const response: DashboardSummary = await ApiFetch.get('/dashboard/summary')
    return response
  }
}